var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticStyle:{"display":"flex","justify-content":"flex-end"},attrs:{"cols":"6"}},[_c('v-img',{attrs:{"src":_vm.logoS,"max-height":"70","max-width":"70"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }